// 👇 all imports remain the same
import api from '@api';
import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { parseISO, format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';


import './GameInLeagueAuth.css'

function GameInLeagueAuth({ leagueId, seasonId, teams: externalTeams }) {
  const { user } = useAuth();
  const [games, setGames] = useState([]);
  const uniqueDates = [...new Set(games.map(g => g.date))].sort();
  const [teams, setTeams] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedGames, setSelectedGames] = useState([]);
  const [message, setMessage] = useState('');
  const [isScoreModalOpen, setIsScoreModalOpen] = useState(false);
  const [selectedGame, setSelectedGame] = useState(null);
  const [dateFilter, setDateFilter] = useState("");
  const [scoreMismatches, setScoreMismatches] = useState({});
  const [isByeModalOpen, setIsByeModalOpen] = useState(false);
  const [byeForm, setByeForm] = useState({ date: '', team: '' });
  const [byes, setByes] = useState([]);
  const [selectedByes, setSelectedByes] = useState([]);
  const [weekOffs, setWeekOffs] = useState([]);
  const [selectedWeekOffs, setSelectedWeekOffs] = useState([]);


  const [gameForm, setGameForm] = useState({
    team1_id: '',
    team2_id: '',
    date: '',
    game_dateTime: '',
    location: '',
    time: '',
    status: 'scheduled',
  });

  const [scoreForm, setScoreForm] = useState({
    score_team1: '',
    score_team2: ''
  });
  const [showWeekOffModal, setShowWeekOffModal] = useState(false);
  const [weekOffForm, setWeekOffForm] = useState({ date: '', reason: '' });
  const navigate = useNavigate();
  const handleCreateWeekOff = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/api/week-offs`, {
        season_id: Number(seasonId),
        league_id: Number(leagueId),
        date: weekOffForm.date,
        reason: weekOffForm.reason,
      }, { withCredentials: true });

      await fetchData();
      setWeekOffForm({ date: '', reason: '' });
      setShowWeekOffModal(false);
      setMessage("Week off created!");
    } catch (err) {
      console.error("❌ Failed to create week off:", err);
      alert("Failed to create week off.");
    }
  };


  const fetchData = async () => {
    try {
      const res = await api.get(`/api/seasonsv2/${seasonId}/leagues/${leagueId}/games`, {
        withCredentials: true
      });

      const fetchedGames = res.data.games || [];
      const fetchedTeams = externalTeams && externalTeams.length
        ? externalTeams
        : (res.data.teams || []);

      setGames(fetchedGames);
      setTeams(fetchedTeams);

      // 🔁 Fetch byes using new route
      const byeRes = await api.get(`/api/bye-dates/season/${seasonId}/league/${leagueId}`, {
        withCredentials: true
      });

      setByes(byeRes.data.byes || []);
      // 🔁 Fetch week-offs
      const offRes = await api.get(`/api/week-offs/season/${seasonId}/league/${leagueId}`, {
        withCredentials: true,
      });
      setWeekOffs(offRes.data || []);


    } catch (error) {
      console.error("❌ Error fetching games or byes:", error);
    }
  };






  // Fetch games + teams
  useEffect(() => {
    if (!seasonId || !leagueId || externalTeams?.length) {
      setTeams(externalTeams); // ✅ set once
      return;
    }
    fetchData();
  }, [seasonId, leagueId, externalTeams]);

  // Fetch byes after teams are available






  const handleCreateGame = async (e) => {
    e.preventDefault();
    if (gameForm.team1_id === gameForm.team2_id) {
      return alert('Teams must be different.');
    }

    try {


      await api.post(`/api/seasonsv2/${seasonId}/leagues/${leagueId}/games`, {
        home_team_id: Number(gameForm.team1_id),
        away_team_id: Number(gameForm.team2_id),
        date: gameForm.date, // 👈 send raw local date
        time: gameForm.time, // 👈 send raw local time
        location: gameForm.location,
      }, { withCredentials: true });



      await fetchData(); // call the same fetch function that loads games/teams

      setGameForm({
        team1_id: '',
        team2_id: '',
        date: '',
        location: '',
        time: '',
        status: 'scheduled',
      });

      setIsModalOpen(false);
    } catch (error) {
      console.error("❌ Error creating game:", error?.response?.data || error.message || error);
      alert("Failed to create game. Check the console for more details.");
    }
  };

  const handleGameForm = (e) => {
    const { name, value } = e.target;
    setGameForm(prev => ({
      ...prev,
      [name]: value === '' ? '' : value // keep it as string and convert only when needed

    }));
  };


  useEffect(() => {
    const savedFilter = sessionStorage.getItem("gameDateFilter");
    if (savedFilter) {
      setDateFilter(savedFilter);
    }
  }, []);
  useEffect(() => {
    const fetchMismatches = async () => {
      try {
        const res = await api.get(`/api/seasonsv2/${seasonId}/leagues/${leagueId}/score-mismatches`, {
          withCredentials: true
        });
        setScoreMismatches(res.data.mismatches || {});
      } catch (err) {
        console.error("Error fetching mismatches", err);
      }
    };

    if (games.length) fetchMismatches();
  }, [games]);


  // useEffect(() => {
  //   const detectMismatches = async () => {
  //     const mismatches = {};

  //     for (const game of games) {
  //       // Only check completed games
  //       if ((game.score_team1 ?? 0) + (game.score_team2 ?? 0) === 0) {
  //         mismatches[game.id] = false;
  //         continue;
  //       }

  //       try {
  //         const res = await api.get(`/api/gamesv2/${game.id}`);
  //         const { playerStats, allStats, homeRoster, awayRoster } = res.data;

  //         const ptsStatId = allStats.find(stat => stat.abbreviation === "PTS")?.id;
  //         const values = {};
  //         playerStats.forEach(stat => {
  //           values[`${stat.player_id}-${stat.stat_id}`] = stat.value;
  //         });

  //         const homePlayers = homeRoster.map(r => r.player);
  //         const awayPlayers = awayRoster.map(r => r.player);

  //         const totalHome = homePlayers.reduce((sum, p) => sum + (values[`${p.id}-${ptsStatId}`] || 0), 0);
  //         const totalAway = awayPlayers.reduce((sum, p) => sum + (values[`${p.id}-${ptsStatId}`] || 0), 0);

  //         mismatches[game.id] = totalHome !== (game.score_team1 ?? 0) || totalAway !== (game.score_team2 ?? 0);
  //       } catch (err) {
  //         console.error(`❌ Error checking game ${game.id}:`, err);
  //         mismatches[game.id] = false;
  //       }
  //     }

  //     setScoreMismatches(mismatches);
  //   };

  //   if (games.length) detectMismatches();
  // }, [games]);


  const handleDeleteGames = async () => {
    if (!selectedGames.length) return alert("Please select at least one game to delete.");
    if (!window.confirm("Are you sure you want to delete the selected games?")) return;

    try {
      await Promise.all(
        selectedGames.map(id =>
          api.delete(`/api/seasonsv2/${seasonId}/leagues/${leagueId}/games/${id}`, {
            withCredentials: true
          })
        )
      );

      setGames(prev => prev.filter(game => !selectedGames.includes(game.id)));
      setSelectedGames([]);
      setMessage("Games deleted successfully");
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      console.error("Error deleting games:", error);
    }
  };

  const handleCreateBye = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/api/bye-dates`, {
        date: byeForm.date,
        team_id: byeForm.team, // single ID instead of array
      }, { withCredentials: true });


      setByeForm({ date: '', teams: [] });
      setIsByeModalOpen(false);
      setMessage("Bye created!");
      setTimeout(() => setMessage(""), 3000);

      await fetchData(); // ✅ this already refreshes games + teams + byes
    } catch (err) {
      console.error("Error creating bye:", err);
      alert("Failed to create bye");
    }
  };



  const handleCheckboxChange = (id) => {
    setSelectedGames(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    setSelectedGames(prev =>
      prev.length === games.length ? [] : games.map(g => g.id)
    );
  };

  const openScoreModal = (game) => {
    setSelectedGame(game);
    setScoreForm({
      score_team1: game.score_team1 || '',
      score_team2: game.score_team2 || ''
    });
    setIsScoreModalOpen(true);
  };

  const handleScoreChange = (e) => {
    const { name, value } = e.target;
    setScoreForm(prev => ({ ...prev, [name]: value }));
  };

  const handleUpdateScore = async (e) => {
    e.preventDefault();
    if (!selectedGame) return;

    try {
      const res = await api.put(`/api/seasonsv2/${seasonId}/leagues/${leagueId}/games/${selectedGame.id}`, {
        score_home: scoreForm.score_team1,
        score_away: scoreForm.score_team2,
      }, { withCredentials: true });

      setGames(prev =>
        prev.map(game => (game.id === selectedGame.id ? { ...game, ...res.data } : game))
      );
      setMessage("Score updated successfully");
      setTimeout(() => setMessage(""), 3000);
      setIsScoreModalOpen(false);
    } catch (error) {
      console.error("Error updating score:", error);
    }
  };

  const getTeamNameById = (id) => {
    const team = teams.find(team => team.seasons_leagues_teams_id === id);
    return team ? team.name : 'Unknown Team';
  };

  const getGameDate = (game) => {
    // If it's a BYE entry (no id, no status, has teams)
    if (game.teams && game.date && !game.status) {
      return format(parseISO(game.date), 'MMMM d, yyyy');
    }

    if (game.game_dateTime) {
      return formatInTimeZone(new Date(game.game_dateTime), 'America/Los_Angeles', 'MMMM d, yyyy');
    }

    if (game.date && game.time) {
      return formatInTimeZone(new Date(`${game.date}T${game.time}`), 'America/Los_Angeles', 'MMMM d, yyyy');
    }

    if (game.date) {
      return formatInTimeZone(new Date(game.date), 'America/Los_Angeles', 'MMMM d, yyyy');
    }

    return 'TBD';
  };


  const getGameTime = (game) => {
    if (game.date && game.time) {
      return formatInTimeZone(new Date(`${game.date}T${game.time}`), 'America/Los_Angeles', 'h:mm a');
    }
    if (game.game_dateTime) {
      return formatInTimeZone(new Date(game.game_dateTime), 'America/Los_Angeles', 'h:mm a');
    }
    return 'TBD';
  };


  const formatTime = (time) => {
    if (!time) return "TBD";
    try {
      const [hours, minutes] = time.split(":");
      const date = new Date();
      date.setHours(hours);
      date.setMinutes(minutes);
      return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true });
    } catch {
      return "Invalid";
    }
  };
  const handleDeleteSelected = async () => {
    if (!selectedGames.length && !selectedByes.length && !selectedWeekOffs.length) {
      return alert("Select games, byes, or week-offs to delete.");
    }

    if (!window.confirm("Are you sure you want to delete the selected items?")) return;

    try {
      await Promise.all([
        ...selectedGames.map(id =>
          api.delete(`/api/seasonsv2/${seasonId}/leagues/${leagueId}/games/${id}`, {
            withCredentials: true
          })
        ),
        ...selectedByes.map(id =>
          api.delete(`/api/bye-dates/${id}`, { withCredentials: true })
        ),
        ...selectedWeekOffs.map(id =>
          api.delete(`/api/week-offs/${id}`, { withCredentials: true })
        ),
      ]);


      setGames(prev => prev.filter(g => !selectedGames.includes(g.id)));
      setByes(prev => prev.filter(b => !selectedByes.includes(b.id)));
      setWeekOffs(prev => prev.filter(w => !selectedWeekOffs.includes(w.id)));
      setSelectedGames([]);
      setSelectedByes([]);
      setSelectedWeekOffs([]);
      setMessage("Items deleted successfully");
      setTimeout(() => setMessage(""), 3000);
    } catch (err) {
      console.error("❌ Error deleting items:", err);
      alert("Error occurred while deleting.");
    }
  };

  const weekOffEntries = weekOffs.map((off) => ({
    id: off.id, // ✅ real database ID
    date: off.date,
    reason: off.reason,
    type: 'week_off',
  }));


  const displayRows = [...games, ...byes, ...weekOffEntries]
    .filter((entry) => !dateFilter || entry.date === dateFilter)
    .sort((a, b) => {
      const dateA = new Date(`${a.date}T${a.time || '00:00'}`);
      const dateB = new Date(`${b.date}T${b.time || '00:00'}`);
      return dateA - dateB;
    });


  return (
    <div className="game-in-league-auth-container">
      <div className="league-game-auth-btn-container">

        <button className="delete-league-game-auth-btn" onClick={handleDeleteSelected}>
          🗑️
        </button>

        <select
          className="date-filter-dropdown"
          value={dateFilter}
          onChange={(e) => {
            const newValue = e.target.value;
            setDateFilter(newValue);
            sessionStorage.setItem("gameDateFilter", newValue); // ✅ store in session
          }}

        >
          <option value="">All Dates</option>
          {uniqueDates.map((date) => (
            <option key={date} value={date}>
              {format(parseISO(date), 'MMMM d, yyyy')}
            </option>
          ))}

        </select>

        <button className="add-league-game-auth-btn" onClick={() => setIsModalOpen(true)}>+ Add Game</button>
        <button className="add-league-game-auth-btn" onClick={() => setIsByeModalOpen(true)}>+ Add Bye</button>
        <button className="add-league-game-auth-btn" onClick={() => setShowWeekOffModal(true)}>+ Add Week Off</button>

      </div>
      {showWeekOffModal && (
        <div className="game-schedule-modal-overlay">
          <div className="game-schedule-modal-content">
            <h3>Create Week Off</h3>
            <form onSubmit={handleCreateWeekOff}>
              <label>Date
                <input
                  type="date"
                  value={weekOffForm.date}
                  onChange={(e) => setWeekOffForm(prev => ({ ...prev, date: e.target.value }))}
                  required
                />
              </label>
              <label>Reason (optional)
                <input
                  type="text"
                  value={weekOffForm.reason}
                  onChange={(e) => setWeekOffForm(prev => ({ ...prev, reason: e.target.value }))}
                />
              </label>
              <button type="submit">Create</button>
              <button type="button" onClick={() => setShowWeekOffModal(false)}>Cancel</button>
            </form>
          </div>
        </div>
      )}

      {isByeModalOpen && (
        <div className="game-schedule-modal-overlay">
          <div className="game-schedule-modal-content">
            <h3>Create Bye</h3>
            <form onSubmit={handleCreateBye}>
              <label>Date
                <input
                  type="date"
                  value={byeForm.date}
                  onChange={(e) => setByeForm(prev => ({ ...prev, date: e.target.value }))}
                />
              </label>
              <label>Team</label>
              <select
                value={byeForm.team}
                onChange={(e) => setByeForm(prev => ({ ...prev, team: Number(e.target.value) }))}
                required
              >
                <option value="">Select team</option>
                {teams.map(team => (
                  <option key={team.seasons_leagues_teams_id} value={team.seasons_leagues_teams_id}>
                    {team.name}
                  </option>
                ))}
              </select>

              <button type="submit">Create Bye</button>
              <button type="button" onClick={() => setIsByeModalOpen(false)}>Cancel</button>
            </form>
          </div>
        </div>
      )}

      {isModalOpen && (
        <div className="game-schedule-modal-overlay">
          <div className="game-schedule-modal-content">
            <h3>Create Game</h3>
            <form onSubmit={handleCreateGame}>
              <label>
                Home Team
                <select
                  name="team1_id"
                  value={gameForm.team1_id || ''}
                  onChange={handleGameForm}
                  required
                >

                  <option value="">Select a team</option>
                  {teams.map(team => (
                    <option
                      key={team.seasons_leagues_teams_id}
                      value={team.seasons_leagues_teams_id}
                    >
                      {team.name}
                    </option>


                  ))}
                </select>

              </label>

              <label>
                Away Team
                <select
                  name="team2_id"
                  value={gameForm.team2_id || ''}
                  onChange={handleGameForm}
                  required
                >

                  <option value="">Select a team</option>
                  {teams.map(team => (
                    <option
                      key={team.seasons_leagues_teams_id}
                      value={team.seasons_leagues_teams_id}
                    >
                      {team.name}
                    </option>


                  ))}
                </select>
              </label>

              <label>Date
                <input type="date" name="date" value={gameForm.date} onChange={handleGameForm} />
              </label>
              <label>Location
                <input type="text" name="location" value={gameForm.location} onChange={handleGameForm} />
              </label>
              <label>Time
                <input type="time" name="time" value={gameForm.time} onChange={handleGameForm} />
              </label>

              <button type="submit">Create</button>
              <button type="button" onClick={() => setIsModalOpen(false)}>Cancel</button>
            </form>
          </div>
        </div>
      )}

      <div className="game-schedule-container">
        {message && <p className="message">{message}</p>}

        <table className="game-schedule-table">
          <thead>
            <tr>
              <th><input
                type="checkbox"
                checked={
                  [...games, ...byes]
                    .filter(e => !dateFilter || e.date === dateFilter)
                    .every(entry =>
                      entry.teams
                        ? selectedByes.includes(entry.id)
                        : selectedGames.includes(entry.id)
                    )
                }
                onChange={(e) => {
                  const filteredGames = games.filter(g => !dateFilter || g.date === dateFilter);
                  const filteredByes = byes.filter(b => !dateFilter || b.date === dateFilter);

                  if (e.target.checked) {
                    setSelectedGames(filteredGames.map(g => g.id));
                    setSelectedByes(filteredByes.map(b => b.id));
                  } else {
                    setSelectedGames([]);
                    setSelectedByes([]);
                  }
                }}
              />
              </th>
              <th>ID</th>
              <th>Date</th>
              <th>Matchup</th>
              <th>Location</th>
              <th>Time</th>
              <th>Status</th>
              <th>Results</th>
            </tr>
          </thead>
          <tbody>
            {games.length === 0 && byes.length === 0 ? (
              <tr><td colSpan="8">No games or byes available</td></tr>
            ) : (
              displayRows.map((entry, index) => {
                if (entry.type === 'week_off') {
                  return (
                    <tr key={entry.id} className="week-off-row">
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedWeekOffs.includes(entry.id)}
                          onChange={() => {
                            setSelectedWeekOffs(prev =>
                              prev.includes(entry.id)
                                ? prev.filter(id => id !== entry.id)
                                : [...prev, entry.id]
                            );
                          }}
                        />
                      </td>
                      <td colSpan={7}>
                        🛑 <strong>{format(parseISO(entry.date), 'MMMM d, yyyy')}</strong> — No Games ({entry.reason || 'Off Week'})
                      </td>
                    </tr>

                  );
                }
                const isBye = !!entry.teams;
                return (
                  <tr
                    key={`entry-${index}`}
                    className="clickable-row"
                    onClick={() => {
                      if (!isBye) {
                        navigate(`/games/${entry.id}`);
                      }
                    }}
                    style={{ cursor: isBye ? 'default' : 'pointer' }}
                  >
                    <td
                      onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        type="checkbox"
                        checked={
                          entry.teams
                            ? selectedByes.includes(entry.id)
                            : selectedGames.includes(entry.id)
                        }
                        onChange={() => {
                          if (entry.teams) {
                            setSelectedByes(prev =>
                              prev.includes(entry.id)
                                ? prev.filter(id => id !== entry.id)
                                : [...prev, entry.id]
                            );
                          } else {
                            setSelectedGames(prev =>
                              prev.includes(entry.id)
                                ? prev.filter(id => id !== entry.id)
                                : [...prev, entry.id]
                            );
                          }
                        }}
                      />
                    </td>

                    <td>{index + 1}</td>
                    <td>{getGameDate(entry)}</td>
                    <td>
                      {isBye
                        ? entry.teams.map((t) => getTeamNameById(t)).join(', ') + ' (BYE)'
                        : `${entry.homeTeam?.name || 'Unknown'} vs ${entry.awayTeam?.name || 'Unknown'}`}
                    </td>
                    <td>{isBye ? '—' : entry.location}</td>
                    <td>{isBye ? '—' : getGameTime(entry)}</td>
                    <td>
                      {isBye
                        ? 'Bye'
                        : (entry.score_team1 > 0 || entry.score_team2 > 0
                          ? "Completed"
                          : entry.status?.charAt(0).toUpperCase() + entry.status?.slice(1))}
                    </td>
                    <td>
                      {isBye ? '—' : (
                        <>
                          {scoreMismatches[entry.id] && <span title="Mismatch: Results & Team Total"> ⚠️</span>}
                          {entry.score_team1 ?? 0} - {entry.score_team2 ?? 0}
                        </>
                      )}
                    </td>
                  </tr>

                );
              })
            )}
          </tbody>

        </table>

        {isScoreModalOpen && selectedGame && (
          <div className="game-schedule-modal-overlay">
            <div className="game-schedule-modal-content">
              <h3>Update Score</h3>
              <form onSubmit={handleUpdateScore}>
                <label>
                  {getTeamNameById(selectedGame.team1_id)}
                  <input type="number" name="score_team1" value={scoreForm.score_team1} onChange={handleScoreChange} required />
                </label>
                <label>
                  {getTeamNameById(selectedGame.team2_id)}
                  <input type="number" name="score_team2" value={scoreForm.score_team2} onChange={handleScoreChange} required />
                </label>
                <button type="submit">Update</button>
                <button type="button" onClick={() => setIsScoreModalOpen(false)}>Cancel</button>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default GameInLeagueAuth;
